export type HeatmapViewMode = 'normal' | 'average2w' | 'average4w' | 'average8w';

/** First paint uses the 4-week average grid. */
export const DEFAULT_HEATMAP_VIEW_MODE: HeatmapViewMode = 'average4w';

export const HEATMAP_VIEW_OPTIONS: ReadonlyArray<{ id: HeatmapViewMode; label: string }> = [
  { id: 'normal', label: 'Normal' },
  { id: 'average2w', label: '2-week avg' },
  { id: 'average4w', label: '4-week avg' },
  { id: 'average8w', label: '8-week avg' },
];

export function averagingWeekCount(view: HeatmapViewMode): number | null {
  switch (view) {
    case 'average2w':
      return 2;
    case 'average4w':
      return 4;
    case 'average8w':
      return 8;
    default:
      return null;
  }
}

export function isAverageHeatmapViewMode(view: HeatmapViewMode): boolean {
  return averagingWeekCount(view) !== null;
}

/**
 * The chart always needs the current week (`view=normal`).
 * Average grids request a widened window, so fetch the selected week separately.
 */
export function shouldFetchWeekChartSeparately(view: HeatmapViewMode): boolean {
  return isAverageHeatmapViewMode(view);
}

export function heatmapViewWeekLabel(view: HeatmapViewMode, weekRangeLabel: string): string {
  const weeks = averagingWeekCount(view);
  if (!weeks) return `Week: ${weekRangeLabel}`;
  return `${weeks}-week avg ending ${weekRangeLabel}`;
}
